import React from "react"

import { FormControl, FormLabel } from "@mui/joy";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useListFiltersAdapter } from "src/mtska-frontend-app-component/utils";
import { CampaignLeadList } from "src/mtska-frontend-modules/modules/CampaignManagement";
import JSONPretty from "react-json-pretty";

const InputListCampaignLead = ({
    control,
    editing,
    name,
    label,
    readonly,
    className = "",
    dataProviderName,
    defaultSelectedValues,
    enableSelection,
    disableMultipleRowSelection,
    hideTableToolbar = false,
    filters,
    relation
}) => {

    const { adaptRelationshipFilters } = useListFiltersAdapter();
    const { t } = useTranslation();
    if (!editing) readonly = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (readonly) ? " readonly" : "";
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => {

                const rowSelectionExternalListener = (selectionModel) => {
                    onChange(selectionModel);
                }

                filters = adaptRelationshipFilters(filters, relation, formState);

                const visible = (relation.campaignId || (!relation.campaignId && filters?.items[0]?.field == '_related_campaign_id'))
                return (
                    visible && <div className={("form-element list " + className).trim()}>
                        <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                            <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                            {/* nell'attivatoreaa
                            <JSONPretty data={filters} className="json-wrapper" />
                            <JSONPretty data={relation} className="json-wrapper" /> */}
                            <CampaignLeadList
                                leftButtons={[]}
                                rightButtons={[]}
                                dataProviderName={dataProviderName}
                                title={label}
                                rowSelectionExternalListener={rowSelectionExternalListener}

                                defaultSelectedValues={defaultSelectedValues}
                                enableSelection={enableSelection}
                                disableMultipleRowSelection={disableMultipleRowSelection}

                                className={className}
                                hideTableToolbar={false}
                                hideTableFooter={false}
                                isEmbedded={true}
                                filters={filters}
                                relation={relation}
                            />
                        </FormControl>
                    </div>
                )
            }}
        />
    );
};


export default InputListCampaignLead;